// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.t-vue-lbtn-grp {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
